import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'parseFloat'})

export class ParseFloatPipe implements PipeTransform {
  transform(value: string): number {
    return Number.parseFloat(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/pipes/parse-float.pipe.ts